import { useSidebar } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";

export const MainContent = ({ children }: React.PropsWithChildren) => {
  const { isOpen } = useSidebar();

  return (
    <main
      data-testid="main-content"
      className={cn(
        "grow transition-all duration-200 h-[calc(100vh-var(--top-navbar-height))] px-0 md:px-4 bg-background",
        isOpen && "md:ps-0",
      )}
    >
      {/* NOTE: NSAI-5822 — the content area is one flat surface. It used to be
          an inset, rounded, differently tinted box sitting on a second tinted
          main element, which stacked three near-identical navies at night; the
          page below paints --background, so this wrapper only owns spacing. */}
      {/* NOTE: NSAI-5822 — vertical padding trimmed to a hairline: the page
          inside adds its own p-5, so 16px here stacked into a visible gap under
          the header and above the bottom edge. */}
      {/* NOTE: NSAI-7288 — the content runs to the bottom of the window. A 2rem
          footer bar used to sit under it, holding only a docs link (also in the
          user menu) and the copyright (now at the foot of the user menu), and
          it pushed the chat composer up for nothing. */}
      {/* NOTE: NSAI-6650 — `Header` insets the breadcrumb by this padding plus
          the pages' own 20px, so the breadcrumb lines up with the page under
          it. Change the horizontal padding here and it changes there too. */}
      <div className="h-full px-4 pt-1 pb-2">{children}</div>
    </main>
  );
};
